module.exports = __webpack_public_path__ + "img/EN.ce8be7d0.svg";